import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M10 21V3h8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6 16h9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10 9.5h7", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "SwissFranc";
const SwissFranc = memo(themed(Icon));
export {
  SwissFranc
};
//# sourceMappingURL=swiss-franc.js.map
